import { render, staticRenderFns } from "./addGoal.vue?vue&type=template&id=6da9081d&scoped=true"
import script from "./addGoal.vue?vue&type=script&lang=js"
export * from "./addGoal.vue?vue&type=script&lang=js"
import style0 from "./addGoal.vue?vue&type=style&index=0&id=6da9081d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9081d",
  null
  
)

export default component.exports